import { Attributes, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class Bank extends ModelBase {
    static typeName = "Bank";

    public bankId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    @Attributes.Display("Bank")
    public bankName: string = "";

    public modifiedBy: number = 0;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.bankName) {
            return "New bank";
        } else {
            return this.bankName;
        }
    }
}